import { render, staticRenderFns } from "./InlinePublishForm.vue?vue&type=template&id=4353eb22&"
import script from "./InlinePublishForm.vue?vue&type=script&lang=js&"
export * from "./InlinePublishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports